import {ResearchPaperDTO, ScreeningResultDTO} from '../dto/research-paper';
import {ScreeningProcessDTO} from '../dto/screening-process';
import {PlanItem} from '../../../utils/models/plain-item';

export function paperAuditedScreening(paper: ResearchPaperDTO, screeningTwo?: boolean): boolean | undefined {
  if (!paper.latestScreeningRun) {
    return undefined;
  }
  if (screeningTwo) {
    if (paper.latestScreeningRun.screeningTwo) {
      return paper.latestScreeningRun.screeningTwo?.audited
    }
    return undefined;
  }
  if (paper.latestScreeningRun.screeningOne) {
    return paper.latestScreeningRun.screeningOne?.audited
  }
  return undefined;
}

export function paperPassedScreening(paper: ResearchPaperDTO, screeningTwo?: boolean): boolean | undefined {
  if (!paper.latestScreeningRun) {
    return undefined;
  }
  if (screeningTwo) {
    if (paper.latestScreeningRun.screeningTwo) {
      return paper.latestScreeningRun.screeningTwo?.passed
    }
    return undefined;
  }
  if (paper.latestScreeningRun.screeningOne) {
    return paper.latestScreeningRun.screeningOne?.passed
  }
  return undefined;
}

export function paperScreeningResult(paper: ResearchPaperDTO, screeningTwo?: boolean): ScreeningResultDTO[] {
  if (!paper.latestScreeningRun) {
    return [];
  }
  if (screeningTwo) {
    if (paper.latestScreeningRun.screeningTwo) {
      return paper.latestScreeningRun.screeningTwo?.result
    }
    return [];
  }
  if (paper.latestScreeningRun.screeningOne) {
    return paper.latestScreeningRun.screeningOne?.result
  }
  return [];
}

export function paperCompleteManuelOverride(paper: ResearchPaperDTO, screeningTwo?: boolean): boolean {
  if (!paper.latestScreeningRun) {
    return false;
  }
  if(screeningTwo) {
    return paper.latestScreeningRun.manuelOverrideScreeningTwo || false;
  }
  return paper.latestScreeningRun.manuelOverrideScreeningOne || false;
}


export function paperHasManuelOverride(paper: ResearchPaperDTO): boolean {
  const screeningOneCount = paperScreeningResult(paper).filter(result => !!result.manuelOverride).length;
  const screeningTwoCount = paperScreeningResult(paper, true).filter(result => !!result.manuelOverride).length;

  return !!screeningOneCount || !!screeningTwoCount;
}

export function paperHasManuelAccepted(paper: ResearchPaperDTO, screeningTwo?: boolean): boolean | undefined {
  if (!paper.latestScreeningRun) {
    return undefined;
  }
  const screeningOverCount = paperCompleteManuelOverride(paper, screeningTwo);
  if (!screeningOverCount) {
    return false;
  }
  const result = paperPassedScreening(paper, screeningTwo);

  return !(result);

}


export function getTotalCounts(paper: ResearchPaperDTO, manual: boolean): PlanItem[] {
  const allScreenings: ScreeningProcessDTO[] = [...(paper.oldScreeningProcesses ?? []), ...(paper.latestScreeningRun ? [paper.latestScreeningRun] : [])];
  let total: number = 0;
  let screeningOne: number = 0;
  let screeningTwo: number = 0;

  for (let screening of allScreenings) {
    if (manual) {
      if (screening.manuelOverrideScreeningOne || screening.manuelOverrideScreeningTwo) {
        total++;
        if (screening.manuelOverrideScreeningOne) {
          screeningOne++;
        }
        if (screening.manuelOverrideScreeningTwo) {
          screeningTwo++;
        }
      }
    } else {
      if (screening.screeningOne) {
        total++;
        if (screening.screeningOne && screening.screeningOne.passed) {
          screeningOne++;
        }
      }
      if (screening.screeningTwo && screening.screeningTwo.passed) {
        screeningTwo++;
      }
    }
  }
  return [
    {label: 'Total', value: '' + total},
    {label: 'Passed Title/Abstract', value: '' + screeningOne},
    {label: 'Passed Full/Text', value: '' + screeningTwo}
  ]
}
